import { useGetAudienceDesignatorOptions } from '@/api/hooks/data-mappings/useGetAudienceDesignatorOptions';
import DesignatorSelector from './DesignatorSelector';

export default function AudienceDesignator({
  formValues,
  isUpdating,
  onAudienceDesignatorChange,
  removeAudienceDesignator,
  addAudienceDesignator,
}) {
  const { audienceDesignatorOptions } = useGetAudienceDesignatorOptions();

  return (
    <DesignatorSelector
      values={formValues?.audience_designators || []}
      options={audienceDesignatorOptions}
      onChange={onAudienceDesignatorChange}
      onRemove={removeAudienceDesignator}
      onAdd={addAudienceDesignator}
      disabled={!isUpdating('data-mapping')}
      label='Audience Designator'
      tooltip='Create a composite key for audience designation by selecting multiple columns from the available data columns'
      previewTooltip="This is how the audience designator will be formatted on the audience page. Each selected column's value will be combined with hyphens to create a unique identifier."
    />
  );
}
